import React, { useState, useEffect, useRef } from "react";
import {
  Globe,
  Zap,
  Clock,
  Bot,
  CalendarCheck,
  Sparkles,
  Circle,
  CheckCircle2,
  Play,
  ArrowRight,
  Gift,
  Phone,
  Lock,
  CreditCard,
  ShieldCheck,
  Check,
} from "lucide-react";
import "./QuickAgent.css";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../Components/Loader/Loader";
import {
  getAgentDetails,
  createWidgetWebCall,
  createQuickAgentPayment,
  fetchTelnyxNumber,
} from "../lib/Store";
import { RetellWebClient } from "retell-client-js-sdk";
export default function QuickAgentSetup() {
  const { agentId } = useParams();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState("landing");
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [isCalling, setIsCalling] = useState(false);
  const [loadingText, setLoadingText] = useState("Scanning website data...");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [isValidAgent, setIsValidAgent] = useState(false);
  const [checkingAgent, setCheckingAgent] = useState(true);
  const [isFromAgent, setIsFromAgent] = useState(false);
  const [agentName, setAgentName] = useState(null);
  const [agentAccent, setagentAccent] = useState(null);
  const [businessName, setbusinessName] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [onCall, setOnCall] = useState(false);
  const [callLabel, setCallLabel] = useState("Call REX");
  const [callStatusText, setCallStatusText] = useState("Ready");
  const [phoneIcon, setPhoneIcon] = useState("/Svg/Phone-call.svg");
  const [agentIds, setAgentId] = useState(null);
  const [avatorUrl, setavatarUrl] = useState(null);
  const retellWebClientRef = useRef(null);
  const [isActivating, setIsActivating] = useState(false);
  const [userId, setuserId] = useState(null);
  const [ventryUrl, setventryUrl] = useState(null);
  const [country_code, setcountry_code] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [businessCity, setbusinessCity] = useState(null);
  const [businessState, setbusinessState] = useState(null);
  const [country, setcountry] = useState(null);
  useEffect(() => {
    retellWebClientRef.current = new RetellWebClient();
  }, []);
  // --- LOGIC ---
  useEffect(() => {
    const verifyAndFetchAgent = async () => {
      try {
        if (!agentId) {
          navigate("/");
          return;
        }
        const data = await getAgentDetails(agentId);

        const { agent, business } = data || {};
        const {
          ventryUrl,
          agentExpireTime,
          agentName,
          agentAccent,
          agent_id: apiAgentId,
          avatar,
          userId,
        } = agent || {};
        console.log(ventryUrl, "ventryUrl");
        const webUrl =
          business?.webUrl || business?.knowledge_base_texts?.website;
        const businessCityy = business?.city;
        const businessState = business?.state;
        const businessName = business?.businessName;
        const country = business?.country_code;
        if (!ventryUrl || String(ventryUrl) !== String(agentId)) {
          navigate("/");
          return;
        }
        if (agentExpireTime == 0) {
          navigate("/");
        }
        const now = Date.now();
        // if (agentExpireTime <= now) {
        //   navigate("/");
        //   return;
        // }
        if (webUrl) {
          setWebsiteUrl(webUrl);
          setIsFromAgent(true);
        }
        if (agentName) {
          setAgentName(agentName);
        }
        if (agentAccent) {
          setagentAccent(agentAccent);
        }
        if (apiAgentId) {
          setAgentId(apiAgentId);
        }
        if (businessName) {
          setbusinessName(businessName);
        }
        if (avatar) {
          setavatarUrl(avatar);
        }
        if (businessCityy) {
          setbusinessCity(businessCityy);
        }
        if (businessState) {
          setbusinessState(businessState);
        }
        if (userId) {
          setuserId(userId);
        }
        if (country) {
          setcountry(country);
        }
        if (ventryUrl) {
          setventryUrl(ventryUrl);
        }
        if (country) {
          setcountry_code(country);
        }
        setIsValidAgent(true);
      } catch (err) {
        console.error("Error fetching agent details:", err);
        // navigate('/');
      } finally {
        setCheckingAgent(false);
      }
    };

    verifyAndFetchAgent();
  }, [agentId, navigate]);

  useEffect(() => {
    const loadNumber = async () => {
      if (!country) return;

      try {
        const number = await fetchTelnyxNumber({
          country,
          // businessCity,
          // businessState,
        });

        setPhoneNumber(number);
      } catch (err) {
        console.error("Failed to fetch number:", err);
      }
    };

    loadNumber();
  }, [country, businessCity, businessState]);

  useEffect(() => {
    const savedStep = localStorage.getItem("quickAgentStep");

    if (savedStep) {
      if (savedStep === "loading") {
        setCurrentStep("preview");
      } else {
        setCurrentStep(savedStep);
      }
    }
  }, []);

  const handleTestCall = async () => {
    if (buttonDisabled) return;
    if (onCall) {
      try {
        setButtonDisabled(true);
        if (retellWebClientRef.current) {
          await retellWebClientRef.current.stopCall();
        }
        setOnCall(false);
        setIsCalling(false);
        setCallLabel("Call REX");
        setCallStatusText("Call ended");
        setPhoneIcon("/Svg/Phone-call.svg");
      } catch (err) {
        console.error("Error ending call:", err);
        setCallStatusText("Failed to end call");
      } finally {
        setButtonDisabled(false);
      }
      return;
    }
    if (!agentIds) {
      console.error("Agent ID missing, cannot start call");
      alert("Agent not ready yet. Please try again in a moment.");
      return;
    }
    setButtonDisabled(true);
    try {
      if (navigator?.mediaDevices?.getUserMedia) {
        try {
          await navigator.mediaDevices.getUserMedia({ audio: true });
        } catch (err) {
          console.error("Microphone error:", err);
          alert("Please allow microphone access to make call.");
          setButtonDisabled(false);
          return;
        }
      }
      setOnCall(true);
      setIsCalling(true);
      setCallLabel("Calling...");
      setCallStatusText("Connecting...");
      setPhoneIcon("/Svg/Hangup.svg");
      const data = await createWidgetWebCall(agentIds);
      if (data?.access_token && data?.call_id) {
        if (retellWebClientRef.current) {
          await retellWebClientRef.current.startCall({
            accessToken: data.access_token,
          });
        }
        setCallStatusText(`In Call with ${agentName || "agent"}`);
        setCallLabel("Connected");
      } else {
        setCallStatusText("Unable to start call");
        setCallLabel("Call REX");
        setPhoneIcon("/Svg/Phone-call.svg");
        setOnCall(false);
        setIsCalling(false);
      }
    } catch (err) {
      console.error("Call failed:", err);
      setCallStatusText("Call failed");
      setCallLabel("Call REX");
      setPhoneIcon("/Svg/Phone-call.svg");
      setOnCall(false);
      setIsCalling(false);
    } finally {
      setButtonDisabled(false);
    }
  };

  const startFlow = () => {
    if (!websiteUrl) return alert("Please enter a website");
    setCurrentStep("loading");
    setLoadingProgress(0);
  };

  useEffect(() => {
    if (currentStep === "loading") {
      const interval = setInterval(() => {
        setLoadingProgress((prev) => {
          const next = prev + Math.floor(Math.random() * 8) + 1;
          if (next >= 100) {
            clearInterval(interval);
            return 100;
          }
          return next;
        });
      }, 100);
      return () => clearInterval(interval);
    }
  }, [currentStep]);

  useEffect(() => {
    if (currentStep === "loading") {
      const interval = setInterval(() => {
        setLoadingProgress((prev) => {
          const next = prev + Math.floor(Math.random() * 8) + 1;
          if (next >= 100) {
            clearInterval(interval);
            return 100;
          }
          return next;
        });
      }, 100);
      return () => clearInterval(interval);
    }
  }, [currentStep]);

  useEffect(() => {
    if (loadingProgress > 30) setLoadingText("Analyzing Service Menu...");
    if (loadingProgress > 60) setLoadingText("Training AI Voice Model...");
    if (loadingProgress > 90) setLoadingText("Finalizing Configuration...");

    if (loadingProgress === 100) {
      setTimeout(() => {
        setCurrentStep("preview");
        localStorage.setItem("quickAgentStep", "preview");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 800);
    }
  }, [loadingProgress]);

  const switchStep = (step) => {
    setCurrentStep(step);
    localStorage.setItem("quickAgentStep", step);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleClaimAgent = async () => {
    if (isActivating) return;
    setIsActivating(true);
    try {
      const res = await createQuickAgentPayment(
        agentIds,
        userId,
        "price_1RcCWpSCQQfKS3WDnyGZU5LA",
        agentName,
        businessName,
        ventryUrl
      );
      const checkoutUrl = res?.data?.checkoutUrl || res?.checkoutUrl;
      if (checkoutUrl) {
        window.open(checkoutUrl, "_self");
      }
    } catch (err) {
      console.error("Failed to start free trial:", err);
      alert(
        "Something went wrong while starting free trial. Please try again."
      );
    } finally {
      setIsActivating(false);
    }
  };

    if (checkingAgent) {
    return (
      <>
    <Loader />
      </>
      // <div className="loader-screen">
      //   <div className="loader-spinner"></div>
      //   <p>Loading your agent...</p>
      // </div>
    );
  }

  return (
    <>
      <div className="container">
        {/* NAVBAR */}
        <nav className="navbar">
          <div className="navInner">
            <div className="logoArea">
              <img
                src="/Svg/rexpt-logo.svg"
                alt="Rexpt Logo"
                className="logoImage"
              />
            </div>
            <div className="navTagline">AI Voice Receptionist for Pros</div>
          </div>
        </nav>

        {/* MAIN CONTENT */}
        <main className="main">
          {/* STEP 1: LANDING */}
          {currentStep === "landing" && (
            <div className="landingContainer">
              <div>
                <span className="badge">Build Your Agent in 30 Seconds</span>
                <h1 className="heroTitle">
                  Turn Missed Calls Into{" "}
                  <span className="gradientText">Revenue</span>
                </h1>
                <p className="heroSubtitle">
                  Enter your business website below. Our AI will instantly scan
                  your services, pricing, and hours to build a fully trained
                  Voice Receptionist.
                </p>
              </div>

              <div className="inputWrapper">
                <div className="inputFieldContainer">
                  <div className="inputIcon">
                    <Globe size={20} />
                  </div>
                  <input
                    type="text"
                    value={websiteUrl}
                    onChange={(e) => setWebsiteUrl(e.target.value)}
                    placeholder="www.yourwebsite.com"
                    className="mainInput"
                    readOnly={isFromAgent}
                  />
                </div>
                <button onClick={startFlow} className="primaryButton">
                  Build My Agent <ArrowRight size={16} />
                </button>
              </div>

              <div className="featureGrid">
                <FeatureItem
                  icon={<Zap color="#eab308" />}
                  color="#fefce8"
                  label="Instant Setup"
                />
                <FeatureItem
                  icon={<Clock color="#3b82f6" />}
                  color="#eff6ff"
                  label="24/7 Answering"
                />
                <FeatureItem
                  icon={<Bot color="#6524eb" />}
                  color="#f3e8ff"
                  label="Human Voice"
                />
                <FeatureItem
                  icon={<CalendarCheck color="#22c55e" />}
                  color="#f0fdf4"
                  label="Auto-Booking"
                />
              </div>
            </div>
          )}

          {/* STEP 2: LOADING */}
          {currentStep === "loading" && (
            <div className="loadingContainer">
              <div className="loadingIcon">
                <Sparkles size={40} color="#6524eb" />
              </div>
              <h2 className="loadingTitle">Building Your Agent...</h2>

              <div className="progressContainer">
                <div className="progressHeader">
                  <span>{loadingText}</span>
                  <span className="brandPurple">{loadingProgress}%</span>
                </div>
                <div className="progressBarBg">
                  <div
                    className="progressBarFill"
                    style={{ width: `${loadingProgress}%` }}
                  ></div>
                </div>

                <div className="loadingList">
                  <LoadingItem
                    completed={loadingProgress > 30}
                    text="Learning Services & Pricing"
                  />
                  <LoadingItem
                    completed={loadingProgress > 60}
                    text="Training AI Voice Model"
                  />
                  <LoadingItem
                    completed={loadingProgress > 90}
                    text="Creating Booking Flows"
                  />
                </div>
              </div>
            </div>
          )}

          {/* STEP 3: PREVIEW */}
          {currentStep === "preview" && (
            <div className="previewContainer">
              <div className="topBar"></div>

              <span
                className="badge"
                style={{
                  borderColor: "transparent",
                  backgroundColor: "#dcfce7",
                  color: "#15803d",
                }}
              >
                Ready to Deploy
              </span>

              <h2 className="heroTitle" style={{ fontSize: "1.875rem" }}>
                Meet Your New Receptionist
              </h2>
              <p className="heroSubtitle" style={{ marginBottom: "1rem" }}>
                It has learned everything about{" "}
                <span
                  style={{
                    color: "#6524eb",
                    fontWeight: "bold",
                    textDecoration: "underline",
                  }}
                >
                  {websiteUrl}
                </span>
                .
              </p>

              <div className="audioPlayer">
                <div className="upperbarDiv">
                  <div className="upperbar">
                    <div className="profile">
                      <img
                        src={`https://rex-bk.truet.net/${avatorUrl}`}
                        alt="profile"
                      />
                    </div>
                    <div className="profilename">
                      <h1>{agentName ?? "Amelia"}</h1>
                      <p>English: {agentAccent ?? "British Accent"}</p>
                    </div>
                  </div>
                  {/* <div className="testcall">
                    <img src="/Svg/test-call-btn.svg" alt="test-call-btn" />
                  </div> */}
                </div>
                <div className="detailsBarDiv">
                  <div className="detailsBar">
                    <div>
                      <p className="forname">
                        For :{" "}
                        <span className="companyName"> {businessName}</span>
                      </p>
                      <div className="numberasign">
                        <p>AI Agent Toll Free</p>
                        <h2>{phoneNumber || "+14408140017"}</h2>
                      </div>
                    </div>
                  </div>
                  <div className="buttonBar">
                    <div className="buttonBar">
                      <button
                        className={`callbtn ${onCall ? "disconnect" : "call"} ${
                          buttonDisabled ? "disabled" : ""
                        }`}
                        onClick={handleTestCall}
                        disabled={buttonDisabled}
                      >
                        {onCall ? "End" : "Call"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <button
                onClick={handleClaimAgent}
                className="fullWidthButton"
                disabled={isActivating}
              >
                {isActivating ? (
                  <div className="loader"></div>
                ) : (
                  <>
                    Claim This Agent & Go Live <ArrowRight size={20} />
                  </>
                )}
              </button>
              <p
                style={{
                  fontSize: "0.75rem",
                  color: "#9ca3af",
                  marginTop: "1rem",
                }}
              >
                Your agent configuration is saved for 10 minutes.
              </p>
            </div>
          )}

          {/* STEP 4: CHECKOUT */}
          {currentStep === "checkout" && (
            <div className="checkoutGrid">
              {/* Left: Value Stack */}
              <div>
                <h2
                  className="heroTitle"
                  style={{ fontSize: "1.875rem", textAlign: "left" }}
                >
                  Activate Your Agent
                </h2>
                <p style={{ color: "#4b5563", marginTop: "0.5rem" }}>
                  You are one step away from automating your front desk.
                </p>

                <div className="tripwireCard" style={{ marginTop: "1.5rem" }}>
                  <Gift className="tripwireIcon" />
                  <h3
                    style={{
                      fontWeight: "bold",
                      color: "#6524eb",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      position: "relative",
                      zIndex: 10,
                    }}
                  >
                    <Gift size={20} /> Limited Time Offer Activated
                  </h3>
                  <div
                    style={{
                      fontSize: "0.875rem",
                      color: "#000000",
                      marginTop: "0.75rem",
                      position: "relative",
                      zIndex: 10,
                    }}
                  >
                    <p style={{ marginBottom: "0.5rem" }}>
                      We have waived the <strong>$500 Setup Fee</strong> for new
                      accounts today.
                    </p>
                    <p>
                      Your subscription starts with a{" "}
                      <strong>7-Day Free Trial</strong>. You won't be charged
                      for the software today.
                    </p>
                  </div>
                </div>

                <div className="summaryCard">
                  <h3
                    style={{
                      fontWeight: "bold",
                      borderBottom: "1px solid #e5e7eb",
                      paddingBottom: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    Order Summary
                  </h3>

                  <div className="summaryRow">
                    <span style={{ color: "#374151", fontWeight: 500 }}>
                      Rexpt AI Pro (Monthly)
                    </span>
                    <span className="freeTag">FREE (7 Days)</span>
                  </div>
                  <div className="valueList">
                    <div className="valueItem">
                      <Check size={12} color="#6524eb" /> Includes 24/7 Call
                      Answering{" "}
                      <span className="priceHighlight">($3k Value)</span>
                    </div>
                    <div className="valueItem">
                      <Check size={12} color="#6524eb" /> Includes CRM
                      Integration{" "}
                      <span className="priceHighlight">($500 Value)</span>
                    </div>
                    <div className="valueItem">
                      <Check size={12} color="#6524eb" /> Includes Knowledge
                      Base Training{" "}
                      <span className="priceHighlight">($500 Value)</span>
                    </div>
                  </div>

                  <div
                    className="summaryRow"
                    style={{
                      marginTop: "1rem",
                      paddingTop: "1rem",
                      borderTop: "1px solid #f3f4f6",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#374151",
                        fontWeight: 500,
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#f3e8ff",
                          padding: "0.25rem",
                          borderRadius: "0.25rem",
                        }}
                      >
                        <Phone size={16} color="#6524eb" />
                      </div>
                      Dedicated Local Line Setup
                    </span>
                    <span
                      style={{
                        fontWeight: 800,
                        color: "#6524eb",
                        fontSize: "1.125rem",
                      }}
                    >
                      $9.99
                    </span>
                  </div>
                  <p
                    style={{
                      fontSize: "0.75rem",
                      color: "#9ca3af",
                      paddingLeft: "2.25rem",
                    }}
                  >
                    One-time provisioning fee.
                  </p>

                  <div className="divider"></div>

                  <div className="totalRow">
                    <div style={{ fontSize: "0.75rem", color: "#6b7280" }}>
                      <p>
                        Subtotal Value:{" "}
                        <span style={{ textDecoration: "line-through" }}>
                          $4,029.00
                        </span>
                      </p>
                      <p className="priceHighlight">Trial Discount: -$299.00</p>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <p
                        style={{
                          fontSize: "0.75rem",
                          fontWeight: "bold",
                          color: "#9ca3af",
                          textTransform: "uppercase",
                        }}
                      >
                        Total Due Today
                      </p>
                      <p className="totalPrice">$9.99</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right: Payment Form */}
              <div className="paymentForm">
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "bold",
                    marginBottom: "1.5rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <Lock size={20} color="#6524eb" /> Secure Checkout
                </h3>

                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    switchStep("thankyou");
                  }}
                >
                  <div className="formGroup">
                    <label className="label">Account Details</label>
                    <input
                      type="email"
                      required
                      placeholder="Email Address"
                      className="darkInput"
                      style={{ marginBottom: "0.75rem" }}
                    />
                    <input
                      type="password"
                      required
                      placeholder="Create Password"
                      className="darkInput"
                    />
                  </div>

                  <div
                    style={{
                      borderTop: "1px solid #1f2937",
                      margin: "1.5rem 0",
                    }}
                  ></div>

                  <div className="formGroup">
                    <label className="label">Payment Method</label>
                    <div
                      style={{ position: "relative", marginBottom: "0.75rem" }}
                    >
                      <input
                        type="text"
                        placeholder="Card Number"
                        className="darkInput"
                        style={{ paddingLeft: "2.5rem" }}
                      />
                      <CreditCard
                        size={20}
                        color="#9ca3af"
                        style={{
                          position: "absolute",
                          top: "0.75rem",
                          left: "0.75rem",
                        }}
                      />
                    </div>
                    <div
                      className="gridDiv"
                      style={{ display: "grid", gap: "1rem" }}
                    >
                      <input
                        type="text"
                        placeholder="MM / YY"
                        className="darkInput"
                      />
                      <input
                        type="text"
                        placeholder="CVC"
                        className="darkInput"
                      />
                    </div>
                  </div>

                  <button type="submit" className="paymentButton">
                    Complete Setup ($9.99)
                  </button>

                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "0.75rem",
                      color: "#6b7280",
                      marginTop: "1rem",
                      lineHeight: "1.5",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "0.25rem",
                        color: "#9ca3af",
                      }}
                    >
                      <ShieldCheck size={12} color="#16a34a" /> Secure 256-bit
                      SSL Encrypted
                    </span>
                    Plan renews at $299/mo after 7 days. Cancel anytime.
                  </p>
                </form>
              </div>
            </div>
          )}

          {/* STEP 5: THANK YOU */}
          {currentStep === "thankyou" && (
            <div className="landingContainer">
              <div
                className="loadingIcon"
                style={{ backgroundColor: "#dcfce7" }}
              >
                <Check size={48} color="#16a34a" />
              </div>

              <h1 className="heroTitle">You're In!</h1>
              <p className="heroSubtitle">
                Your dedicated AI number is being provisioned right now.
              </p>

              <div
                className="summaryCard"
                style={{ textAlign: "left", marginTop: "2rem" }}
              >
                <h3
                  style={{
                    fontWeight: "bold",
                    paddingBottom: "0.5rem",
                    marginBottom: "1rem",
                    borderBottom: "1px solid #e5e7eb",
                  }}
                >
                  Setup Status:
                </h3>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    <div
                      className="iconCircle"
                      style={{
                        width: "2rem",
                        height: "2rem",
                        backgroundColor: "#dcfce7",
                        margin: 0,
                      }}
                    >
                      <Check size={16} color="#16a34a" />
                    </div>
                    <span
                      style={{
                        textDecoration: "line-through",
                        color: "#9ca3af",
                      }}
                    >
                      Payment Verified
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    <div
                      className="iconCircle"
                      style={{
                        width: "2rem",
                        height: "2rem",
                        backgroundColor: "#dcfce7",
                        margin: 0,
                      }}
                    >
                      <Check size={16} color="#16a34a" />
                    </div>
                    <span
                      style={{
                        textDecoration: "line-through",
                        color: "#9ca3af",
                      }}
                    >
                      Agent Knowledge Base Created
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                      padding: "1rem",
                      backgroundColor: "#f3e8ff",
                      borderRadius: "0.75rem",
                      border: "1px solid #d8b4fe",
                    }}
                  >
                    <div
                      className="iconCircle"
                      style={{
                        width: "2rem",
                        height: "2rem",
                        backgroundColor: "#6524eb",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "0.875rem",
                        margin: 0,
                      }}
                    >
                      3
                    </div>
                    <div style={{ flexGrow: 1 }}>
                      <span
                        style={{
                          display: "block",
                          fontWeight: "bold",
                          color: "#6524eb",
                        }}
                      >
                        Action Required
                      </span>
                      <span style={{ fontSize: "0.75rem", color: "#4b5563" }}>
                        Connect your calendar so AI can book.
                      </span>
                    </div>
                    <button
                      style={{
                        backgroundColor: "#000000",
                        color: "white",
                        padding: "0.5rem 1rem",
                        borderRadius: "0.5rem",
                        fontSize: "0.75rem",
                        fontWeight: "bold",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      Connect
                    </button>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                      opacity: 0.5,
                    }}
                  >
                    <div
                      className="iconCircle"
                      style={{
                        width: "2rem",
                        height: "2rem",
                        backgroundColor: "#e5e7eb",
                        color: "#6b7280",
                        fontWeight: "bold",
                        fontSize: "0.875rem",
                        margin: 0,
                      }}
                    >
                      4
                    </div>
                    <span style={{ color: "#6b7280" }}>
                      Call Forwarding Setup
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </>
  );
}

// --- HELPER COMPONENTS ---

function FeatureItem({ icon, color, label }) {
  return (
    <div className="featureItem">
      <div
        className="iconCircle"
        style={{ backgroundColor: color.split(" ")[0] }}
      >
        {icon}
      </div>
      {label}
    </div>
  );
}

function LoadingItem({ completed, text }) {
  return (
    <div className="loadingListItem">
      {completed ? (
        <CheckCircle2 size={20} color="#6524eb" />
      ) : (
        <Circle size={20} color="#9ca3af" />
      )}
      <span className={completed ? "itemCompleted" : "itemPending"}>
        {text}
      </span>
    </div>
  );
}
